import request from '../../domain/utils/request'
import { getService } from '../../parameters'
import SERVICES from '../../services.constants'

export const requestAbTest = () =>
  request.get(getService(SERVICES.ABTEST, '/config-web.json'), {
    responseType: 'json' // we force here responseType to avoid axios detecting type...
    // if file isn’t a valid json file, we’ll get null which is what we want
  })
